// @flow
import React, { useContext } from 'react'

import Dish from './Dish'
import type { DishApiType } from '../../MenuDishesApi'
import { OrderDataContext } from '../OrderData'

import styles from './Dishes.module.scss';

const emptyArr = []

type Props = {
  dishes?: Array<DishApiType>,
  orderFormOpened: boolean,
  balanceLeft?: number,
  loading: boolean,
}

const Dishes = ({ dishes = emptyArr, orderFormOpened, balanceLeft, loading }: Props) => {
  const { isItemInOrder, addToOrder } = useContext(OrderDataContext)
  return (
    <div className={styles.root}>
      {dishes.map((props) => {
        const { guid } = props
        return (
          <Dish
            key={guid}
            orderFormOpened={orderFormOpened}
            balanceLeft={balanceLeft}
            addToOrder={addToOrder}
            isAdded={isItemInOrder(guid)}
            loading={loading}
            // $FlowFixMe
            {...props}
          />
        )
      })}
    </div>
  )
}

export default Dishes
